<template>
  <Menu ref="menuRef" v-bind="$attrs" :model="normalizedModel">
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps || {}" />
    </template>
  </Menu>
</template>

<script>
import Menu from "primevue/menu";
import { normalizeMenuModel } from "@/helpers/menu.js";

export default {
  name: "AppMenu",
  components: { Menu },
  inheritAttrs: false,
  props: {
    model: {
      type: Array,
      default: null,
    },
  },
  computed: {
    normalizedModel() {
      return normalizeMenuModel(this.model);
    },
  },
  methods: {
    toggle(event, target) {
      return this.$refs.menuRef?.toggle(event, target);
    },
    show(event, target) {
      return this.$refs.menuRef?.show(event, target);
    },
    hide() {
      return this.$refs.menuRef?.hide();
    },
  },
};
</script>
